import ChangeDeviceScene from "../screens/change-device";
import DeviceScene from "../screens/device";
import HomeScene from "../screens/home";
import InvoiceScene from "../screens/invoice";
import ManageDeviceScene from "../screens/manage-device";
import QCDeviceScene from "../screens/qc";
import RepairScene from "../screens/repair";
import ReservationScene from "../screens/reservation";
import UploadModelScene from "../screens/upload-model";
import ConfirmSpareDeviceScene from "../screens/spare";
import {
  ROUTE_HOME,
  ROUTE_MANAGE_DEVICE,
  KEY_ROUTE_HOME,
  KEY_ROUTE_DEVICE,
  KEY_ROUTE_MANAGE_DEVICE,
  ROUTE_QC_DEVICE,
  ROUTE_INVOICE_DEVICE,
  ROUTE_REPAIR,
  KEY_ROUTE_QC_DEVICE,
  KEY_ROUTE_INVOICE_DEVICE,
  KEY_ROUTE_REPAIR,
  ROUTE_CHANGE_DEVICE,
  KEY_ROUTE_CHANGE_DEVICE,
  ROUTE_RESERVATION_DEVICE,
  KEY_ROUTE_RESERVATION_DEVICE,
  ROUTE_SPARE_DEVICE,
  KEY_ROUTE_SPARE_DEVICE,
  KEY_ROUTE_UPLOAD_MODEL,
  ROUTE_UPLOAD_MODEL,
} from "./routes-name";

export const ROUTES_ROLE = {
  PRODUCT: [
    ROUTE_HOME,
    ROUTE_MANAGE_DEVICE,
    ROUTE_QC_DEVICE,
    ROUTE_INVOICE_DEVICE,
    ROUTE_REPAIR,
    ROUTE_SPARE_DEVICE,
    ROUTE_CHANGE_DEVICE,
    ROUTE_RESERVATION_DEVICE,
  ],
  ADMIN: [
    ROUTE_HOME,
    ROUTE_MANAGE_DEVICE,
    ROUTE_QC_DEVICE,
    ROUTE_INVOICE_DEVICE,
    ROUTE_REPAIR,
    ROUTE_SPARE_DEVICE,
    ROUTE_CHANGE_DEVICE,
    ROUTE_RESERVATION_DEVICE,
    ROUTE_UPLOAD_MODEL
  ],
  FACTORY: [
    ROUTE_HOME,
    ROUTE_MANAGE_DEVICE,
    ROUTE_QC_DEVICE,
    ROUTE_INVOICE_DEVICE,
  ],
  MECHANIC: [ROUTE_HOME, ROUTE_HOME, ROUTE_MANAGE_DEVICE, ROUTE_REPAIR],
  SUPPORT: [
    ROUTE_HOME,
    ROUTE_MANAGE_DEVICE,
    ROUTE_INVOICE_DEVICE,
    ROUTE_REPAIR,
    ROUTE_SPARE_DEVICE,
    ROUTE_CHANGE_DEVICE,
    ROUTE_RESERVATION_DEVICE,
  ],
};

export const ROUTES_COMPONENT = {
  [KEY_ROUTE_HOME as string]: HomeScene,
  [KEY_ROUTE_DEVICE as string]: DeviceScene,
  [KEY_ROUTE_MANAGE_DEVICE as string]: ManageDeviceScene,
  [KEY_ROUTE_QC_DEVICE as string]: QCDeviceScene,
  [KEY_ROUTE_INVOICE_DEVICE as string]: InvoiceScene,
  [KEY_ROUTE_REPAIR as string]: RepairScene,
  [KEY_ROUTE_CHANGE_DEVICE as string]: ChangeDeviceScene,
  [KEY_ROUTE_RESERVATION_DEVICE as string]: ReservationScene,
  [KEY_ROUTE_SPARE_DEVICE as string]: ConfirmSpareDeviceScene,
  [KEY_ROUTE_UPLOAD_MODEL as string]: UploadModelScene,
};
